// Material UI
import { Container, Grid, Box, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

// Componentes
import UserForm from '@components/Compromisos/UserForm';
import AddressForm from '@components/Compromisos/AddressForm';
import ContactInformationForm from '@components/Compromisos/ContactInformationForm';
import PersonalInformationForm from '@components/Compromisos/PersonalInformationForm';
import SocialMediaForm from '@components/Compromisos/SocialMediaForm';
import AcademyForm from '@components/Compromisos/AcademyForm';
import EmploymentForm from '@components/Compromisos/EmploymentForm';
import FormationForm from '@components/Compromisos/FormationForm';
import InvitationForm from '@components/Compromisos/InvitationForm';
import VolunteerForm from '@components/Compromisos/VolunteerForm';
import SectionCard from '@components/Compromisos/SectionCard';

const FormRegister = (props) => {
  const { event = {}, formik, catalogs, isLoading, isFOCA = false, handleReturn } = props;

  const isBasic = event.idModoEvento === 4;
  const isExterno = [3, 4].includes(event.idModoEvento);

  return (
    <Box component="section" mb={6} sx={{ alignItems: 'center' }}>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button variant="outlined" color="primary" onClick={handleReturn} startIcon={<ArrowBack />}>
              Regresar
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h4" color={'#1769aa'} gutterBottom>
              Para poderse registrar en {`${event.Actividad}`} es necesario proporcionar la siguiente
              información.
            </Typography>
          </Grid>

          {![3, 4].includes(event.idModoEvento) && (
            <Grid item xs={12}>
              <SectionCard number="1" icon="person" title="Datos de Usuario">
                <UserForm isLoading={isLoading} formik={formik} showChip={false} />
              </SectionCard>
            </Grid>
          )}

          <Grid item xs={12}>
            <SectionCard number="2" icon="person" title="Datos personales">
              <PersonalInformationForm
                catalogs={catalogs}
                isLoading={isLoading}
                formik={formik}
                notVigenciaINE
                notNacimiento
                isMenor={formik.values.user?.isMenor}
                isBasic={isBasic}
                showChip={false}
              />
            </SectionCard>
          </Grid>

          <Grid item xs={12}>
            <SectionCard number="3" icon="contact_phone" title="Contacto">
              <ContactInformationForm
                isLoading={isLoading}
                formik={formik}
                disableEmail={isBasic}
                showChip={false}
              />
            </SectionCard>
          </Grid>

          <Grid item xs={12}>
            <SectionCard number="4" icon="home" title="Domicilio donde vive">
              <AddressForm
                catalogs={catalogs}
                isLoading={isLoading}
                formik={formik}
                isBasic={isBasic}
                showChip={false}
              />
            </SectionCard>
          </Grid>

          {/* <Grid item xs={12}>
            <SectionCard number="5" icon="groups" title="Redes Sociales">
              <SocialMediaForm isLoading={isLoading} formik={formik} showChip={false} />
            </SectionCard>
          </Grid> */}

          {!isExterno && (
            <Grid item xs={12}>
              <SectionCard number="6" icon="school" title="Formación Académica">
                <AcademyForm catalogs={catalogs} isLoading={isLoading} formik={formik} showChip={false} />
              </SectionCard>
            </Grid>
          )}

          {isFOCA && !isExterno && (
            <>
              <Grid item xs={12}>
                <SectionCard number="7" icon="badge" title="Experiencia Laboral">
                  <EmploymentForm
                    catalogs={catalogs}
                    isLoading={isLoading}
                    formik={formik}
                    showChip={false}
                  />
                </SectionCard>
              </Grid>

              <Grid item xs={12}>
                <SectionCard number="8" icon="interests" title="Extras">
                  <FormationForm isLoading={isLoading} formik={formik} showChip={false} />
                </SectionCard>
              </Grid>

              <Grid item xs={12}>
                <SectionCard number="9" icon="mail" title="Invitación">
                  <InvitationForm isLoading={isLoading} formik={formik} showChip={false} />
                </SectionCard>
              </Grid>

              <Grid item xs={12}>
                <SectionCard number="10" icon="accessibility" title="Participación en Acción Nacional">
                  <VolunteerForm catalogs={catalogs} isLoading={isLoading} formik={formik} showChip={false} />
                </SectionCard>
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default FormRegister;
